import React from 'react'

const CardLoader = () => {
	return (
		<>
			<div className="centered-justified-loader">
				<span
					className="spinner-border spinner-border-sm"
					role="status"
					aria-hidden="true"
				></span>
			</div>
		</>
	)
}

export default CardLoader
